import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from '@alphabait/ui' // chart'
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from 'recharts'
import { useTranslation } from 'react-i18next'
import { BaseQuestionRendererProps, Question } from './types'
import { getChartColors } from '../utils/colors'
import { ChartWrapper, ChartEmptyState } from './shared'

export function GenderVerticalBars({ question }: BaseQuestionRendererProps) {
  const { t } = useTranslation()
  const buckets = question.aggregates?.buckets || []
  const totalResponses = question.totalRespondents || 0

  // Use normalized gender data if available from transforms
  const normalizedGenders =
    (
      question as Question & {
        normalizedGenders?: Array<{ label: string; count: number }>
      }
    ).normalizedGenders || buckets

  const colors = getChartColors()

  const chartConfig: ChartConfig = {
    count: {
      label: t('dashboard.charts.count'),
      color: colors[0],
    },
  }

  if (normalizedGenders.length === 0) {
    return (
      <ChartWrapper
        title={question.label}
        description={t('dashboard.charts.gender_distribution')}
      >
        <ChartEmptyState message={t('dashboard.charts.no_responses_yet')} />
      </ChartWrapper>
    )
  }

  return (
    <ChartWrapper
      title={question.label}
      description={`${t('dashboard.charts.gender_distribution')} (${t(
        'dashboard.charts.people_answered',
        { count: totalResponses },
      )})`}
    >
      <ChartContainer config={chartConfig} className="h-[250px] w-full m-auto">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={normalizedGenders}
            margin={{ top: 10, right: 50, bottom: 10 }}
          >
            <XAxis
              type="category"
              dataKey="label"
              interval={0}
              tick={{ fontSize: 12 }}
            />
            <YAxis
              type="number"
              domain={[0, 'dataMax']}
              allowDecimals={false}
            />
            <ChartTooltip content={<ChartTooltipContent />} />
            <Bar dataKey="count" fill={colors[0]} radius={12} barSize={40} />
          </BarChart>
        </ResponsiveContainer>
      </ChartContainer>
    </ChartWrapper>
  )
}
